/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Abilities_Limit_HintInputs */



/**
* | output |
* | --- |
* | "Off, the agent may use every ability the chat offers. On, it may use only what you pick." |
*
* @param {Agent_Builder_Abilities_Limit_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_abilities_limit_hint = /** @type {((inputs?: Agent_Builder_Abilities_Limit_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Abilities_Limit_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aus nutzt der Agent alle Fähigkeiten des Chats. Ein nutzt er nur die von Ihnen ausgewählten.")
	return /** @type {LocalizedString} */ ("Off, the agent may use every ability the chat offers. On, it may use only what you pick.")
});